import { HttpAxiosRequest } from 'src/http/httpAxiosBase';
import { z } from 'src/lib';
import { BaseResponse } from 'src/types';
import { SistemaTipo } from "../../../../../types/enum/enum";
import { HttpOperacionInforme } from "../../../api/httpOperacionInforme";
import {
  OperacionNOTESInsert,
  OperacionNOTESParametroView,
  schemaOperacionNOTESInsert,
  schemaOperacionNOTESParametroView
} from '../types/dto';
import { OperacionNOTES, schemaOperacionNOTES } from '../types/types';
import { FilePutFields } from 'src/pages/sistema/api/file-fields';

export const getEndpoint = (url = '') => `operaciones/notes${url}`;

export const HttpNOTES = {
  get: (idOperacion: number): Promise<OperacionNOTES> => {
    return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
      .then(response => {
        const parsed = schemaOperacionNOTES.safeParse(response);

        if (!parsed.success) {
          console.error('Validation Error (HttpNOTES.get):', parsed.error.issues);

          return Promise.reject(new Error('Validation error.'));
        }

        return parsed.data;
      })
      .catch(error => {
        console.error('Network Error (HttpNOTES.get):', error);

        return Promise.reject(new Error('Error obteniendo operación.'));
      });
  },

  post: (operacion: OperacionNOTESInsert): Promise<BaseResponse> => {
    const parsed = schemaOperacionNOTESInsert.safeParse(operacion);

    if (!parsed.success) {
      console.error('Validation Error (HttpNOTES.post):', parsed.error.issues);
      return Promise.reject(new Error('Validation error.'));
    }

    const formData = new FormData();
    formData.append('operacionInsertarJson', JSON.stringify(parsed.data));

    const archivo = (operacion as any)[FilePutFields.File];

    if (archivo) {
      formData.append('file', archivo);
    }

    return HttpAxiosRequest.post(getEndpoint(), formData)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(error => {
        console.error('Network Error (HttpNOTES.post):', error);
        return Promise.reject(new Error('Error insertando operación.'));
      });
  },

  getParametros: (idOperacion: number): Promise<OperacionNOTESParametroView[]> => {
    const endpoint = getEndpoint(`/${idOperacion}/parametros`);

    return HttpAxiosRequest.get(endpoint)
      .then(response => {
        const schemaList = z.array(schemaOperacionNOTESParametroView);
        const parsed = schemaList.safeParse(response);

        if (!parsed.success) {
          console.error('Validation Error (HttpNOTES.getParametros):', parsed.error.issues);

          return Promise.reject(new Error('Validation error.'));
        }

        return parsed.data;
      })
      .catch(error => {
        console.error('Network Error (HttpNOTES.getParametros):', error);

        return Promise.reject(new Error('Error obteniendo parámetros.'));
      });
  },

  descargarInforme: (idOperacion: number): Promise<any> =>
    HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.NOTES),

  getGraficoSubyacentes: (idOperacion: number): Promise<any> =>
    HttpAxiosRequest.getBlob(
      getEndpoint(`/${idOperacion}/archivos/grafico-subyacentes`)
    ),

} as const;
